import { render } from "./HeroiconsSolidTemplate.vue?vue&type=template&id=929976b4"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTemplate.vue"]])

export default __exports__